import React, {useEffect, useRef, useState} from 'react';
import SelectionBox from "./SelectionBox/SelectionBox";
import {convertToValue, getTodayDate} from "./AutoCFunction";
import MapShow from "./MapShow";

import {addOneHour, findMinMaxTimeStamp, videoLikeArray} from "./ArchiveMapFunctions";
import {toast} from "react-toastify";
import _axios from "../../httpService";
import {prefixUrl} from "../../utils/utilsData";
import objectDataHolder from "../Hooks/ObjectDataHolder";

const AutoC = () => {


  const [progressBarValue, setProgressBarValue] = useState(0)
  let [counter, setCounter] = useState(0)
  const [loader, setLoader] = useState(false)
  const [formData, setFormData] = objectDataHolder({
    carType: "all", plate: "",  // pelak
    plateSubmit: false, // on Click Search I will Change And effect send Request
    requestType: "currentLocations", // currentLocations OR locationsArchive
    date: getTodayDate('en'), speed: "", startTime: "",

  })


  const [archiveData, setArchiveData] = objectDataHolder({data: []})
  const [currentDataToShowOnMap, setCurrentDataToShowOnMap] = objectDataHolder({
    type: '', data: [],
  });

  const sendDataAndUpdateUI = () => {

    const pelak = formData.plate;
    const carType = formData.carType;
    const requestType = formData.requestType;
    const date = formData.date;
    let hasLoader = false

    let url = '';
    if (formData.requestType === 'currentLocations') {
      url = `/autocMapData/?request=${formData.requestType}&type=${carType}&pelak=${pelak}`;
      // چون بک توی دیتای آنلاین برای هر ماشین  یه آبجکت میده
      // و در حالت آرشیو  مسیر لوکیشن ها رو توی آرایه  میده
      //
      hasLoader = false
    } else {
      // url = `/autocMapData/index.php?request=${formData.requestType}2&type=${carType}&pelak=${pelak}&date=${date}`
      // url = '/autocMapData/index.php?request=locationsArchive2&type=taxi&pelak=&date=1402/03/27&time=16:00:00'
      url = `/autocMapData/index.php?request=${formData.requestType}2&type=${carType}&pelak=${formData.plate}&date=${formData.date}&time=${formData.startTime}`
      // archiveShower(formData.speed, formData.startTime)
      hasLoader = true
    }

    void sendRequestToReceiveLocationData(url, hasLoader);
  }


  async function sendRequestToReceiveLocationDataPureNoStateChange(url) {
    let receivedData = {data: []}
    await _axios.get(prefixUrl() + url).then(response => {
      const data = response.data;

      if (response.data) {
        receivedData.data = data.locationsArchive
      }
    })


    return receivedData
  }

  async function sendRequestToReceiveLocationData(url, hasLoader, needToReturn = false) {
    let newData = {data: []};
    let receivedData = []
    setLoader(hasLoader)
    await _axios.get(prefixUrl() + url).then(response => {
      const data = response.data;

      if (response.data) {
        receivedData = data.currentLocations || data.locationsArchive
      }
    })

    if (formData.requestType === 'currentLocations') {
      setCurrentDataToShowOnMap({
        type: formData.requestType,
        data: receivedData,
      })
    } else if (formData.requestType === 'locationsArchive') {

      newData = {data: [...archiveData.data, ...receivedData]}

      setArchiveData(newData)
    }
    setLoader(false)
    if (needToReturn) {
      return newData
    }
  }

  const intervalIDRef = useRef(null);
  const startTimer = (callback, timeInMilliSeconds) => {
    intervalIDRef.current = setInterval(() => {

      callback();
    }, timeInMilliSeconds);
  }
  const stopTimer = () => {
    clearInterval(intervalIDRef.current);
    debugger
    intervalIDRef.current = null;
  }


  const getNewData = () => {

    console.log(formData.requestType)
    if (intervalIDRef.current !== null) {
      stopTimer()
    }

    if (formData.requestType === 'currentLocations') {
      startTimer(sendDataAndUpdateUI, 2000)
    } else {
      sendDataAndUpdateUI()
    }
  }

  useEffect(() => {
    if (loader) {
      toast.loading('در حال بارگیری اطلاعات...');
    } else {
      toast.dismiss()
    }
  }, [loader])


  const refreshMapShowWithNewData = (index, myArchiveData) => {

    console.log('index:  ' + index)
    const [h, m, s] = formData.startTime.split(':');
    debugger
    const startPoint = convertToValue(h, m, s)
    debugger

    const result = startPoint + (index / 180)
    console.log(result)
    setProgressBarValue(result)

    // if (myArchiveData.data.length === index) {
    //   stopTimer()
    // }
    setCurrentDataToShowOnMap({
      type: formData.requestType, // data: requestType === 'currentLocations' ? data.currentLocations : data.locationsArchive,
      data: myArchiveData.data[index].locations,
    })


  }


  function waitForSpeedSeconds(speed) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {

        resolve();

        // const data = {message: 'Data fetched successfully'};

        // or reject the Promise with an error
        // reject(new Error('Failed to fetch data'));
      }, speed); // Simulated delay of 2 seconds
    });
  }


  function askDataShowData(speed, index, startTime, myArchiveData) {
    if (myArchiveData.data[index]?.locations === undefined) {

    }

    console.log(intervalIDRef.current)
    if (intervalIDRef.current === null) {

      console.log("EndOfWork!!! STOP")

    }

    if (intervalIDRef.current === 0) {


      let myArchiveDataInternal = {...myArchiveData}
      let newTime = startTime;
      waitForSpeedSeconds(speed).then(res => {

        if (myArchiveData.data.length - 1 === index) {
          //  
          newTime = addOneHour(newTime);
          console.log('sending Request...');
          const url = `/autocMapData/index.php?request=locationsArchive2&type=${formData.carType}&pelak=&date=${formData.date}&time=` + newTime
          sendRequestToReceiveLocationDataPureNoStateChange(url).then(receivedArchiveData => {

            myArchiveDataInternal.data = [...myArchiveDataInternal.data, ...receivedArchiveData.data]
            refreshMapShowWithNewData(index, myArchiveDataInternal)
            askDataShowData(speed, index + 1, newTime, myArchiveDataInternal)

          })
        } else {

          refreshMapShowWithNewData(index, myArchiveDataInternal)

          askDataShowData(speed, index + 1, newTime, myArchiveDataInternal)

        }

      })
    }


  }

  useEffect(() => {

    if (intervalIDRef.current === null && archiveData.data.length > 0) {
      const tSpeed = (20 / formData?.speed || 40);
      // alert(tSpeed)
      // startTimer(doItHere, 1000)

      // const myInterVal = setInterval(doItHere, 100);
      let index = 0;

      intervalIDRef.current = 0
      askDataShowData(tSpeed * 1000, 0, formData.startTime, archiveData);
      console.log("askDataShowData")

    }

  }, [archiveData.data])

  console.log('component RE')
  return (<div>
    <hr/>
    <SelectionBox
      data={formData}
      setData={setFormData}
      onSubmit={getNewData}
      onPlay={() => getNewData()}
      onStop={() => {
        setArchiveData({data: []});
        setCurrentDataToShowOnMap({data: []})
        stopTimer()

      }}
      progressBarValue={progressBarValue}
      setProgressBarValue={setProgressBarValue}
    />
    <MapShow data={currentDataToShowOnMap.data}/>

  </div>);

};

export default AutoC;